import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { CatButton, CatHeading } from 'components/blocks-components';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';

const AddEquipmentHeading = () => {
  const t = useTranslations();
  const { addEquipmentDrawer } = useMyEquipmentDrawer();

  const handleOpen = useCallback(
    () => addEquipmentDrawer.openDrawer(),
    [addEquipmentDrawer]
  );

  return (
    <div className="cat-u-margin-top-xl">
      <CatHeading level="h5">{t('PDP_PARTSDIAGRAM_ADD_EQ_HEADING')}</CatHeading>
      <p className="cat-u-theme-typography-body cat-u-margin-top-md cat-u-margin-bottom-md">
        {t('PARTS_DIAGRAM_ADD_EQ_DESCRIPTION')}
      </p>
      <CatButton variant="contrast" size="md" onClick={handleOpen}>
        {t('PDP_PARTSDIAGRAM_ADD_EQ_HEADING')}
      </CatButton>
    </div>
  );
};

export default AddEquipmentHeading;
